/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button, List, ListItem } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { Values } from '../../../../../../values/Values';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(theme => ({
  root: {},
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: Values.cores.branco,
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '95%',
    fontWeight: theme.typography.fontWeightMedium,
  },
  icon: {
    color: Values.cores.branco,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': {
      color: theme.palette.primary.main
    },
    "&:hover": {
      //you want this to be the same as the backgroundColor above
      color: theme.palette.primary.main,
      backgroundColor: Values.cores.cinza,
    },
    backgroundColor: Values.cores.cinza,
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,

  }
}));

const CustomRouterLink = forwardRef((props, ref) => (
  <div
    ref={ref}
    style={{ flexGrow: 1 }}
  >
    <RouterLink {...props} />
  </div>
));

const SidebarNav = props => {
  const { pages, className, ...rest } = props;

  const classes = useStyles();

  return (
    <List
      {...rest}
      className={clsx(classes.root, className)}
    >
      {pages.map(page => (
        page.visivel &&
        <ListItem
          className={classes.item}
          disableGutters
          key={page.title}
        >
          <Grid
            container

          >
            <Grid
              item
              md={12}
              xs={12}
            >


              <Button
                activeClassName={classes.active}
                className={classes.button}
                component={CustomRouterLink}
                fullWidth
                margin='dense'
                to={page.href}
              >
                <Box>
                  <Box display="flex" flexDirection="wrap">
                    <div className={classes.icon}>{page.icon}</div>
                    {page.title}
                  </Box>

                </Box>



              </Button>
            </Grid>
          </Grid>

        </ListItem>
      ))}
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.array.isRequired
};

export default SidebarNav;
